<template>
  <div class="flex-1">
    <div class="flex items-center gap-3">
      <span class="text-lg font-medium text-gray-900">
        {{ current }}/{{ total }} {{ __('Questions') }}
      </span>
    </div>
    <div class="mt-2 h-2 bg-gray-200 rounded-full overflow-hidden">
      <div
          class="h-full bg-secondary transition-all duration-300 ease-out"
          :style="{ width: `${progressPercentage}%` }"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { __ } from '@/helpers';

const props = defineProps({
  current: {
    type: Number,
    required: true
  },
  total: {
    type: Number,
    required: true
  }
});

const progressPercentage = computed(() => {
  return Math.round((props.current / props.total) * 100);
});
</script>